import { useSyncExternalStore } from 'react';

function subscribe() {
    return () => {};
}

// False during prerender and the hydration pass, true right after. Lets a
// component read browser-only input (e.g. the query string) without a
// hydration mismatch against the prerendered HTML.
export function useIsClient() {
    return useSyncExternalStore(subscribe, () => true, () => false);
}
